import React, {
  AnchorHTMLAttributes,
  DetailedHTMLProps,
  type FC,
  ReactEventHandler,
} from "react";

interface LinkWithConfirmProps
  extends DetailedHTMLProps<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  confirmMessage?: string;
}

const LinkWithConfirm: FC<LinkWithConfirmProps> = ({
  children,
  confirmMessage,
  ...rest
}) => {
  const message = confirmMessage ?? "Are you sure?";
  const handleClick: ReactEventHandler<HTMLAnchorElement> = (ev) => {
    if (!confirm(message)) {
      ev.preventDefault();
    }
  };
  return (
    <a onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};

export { LinkWithConfirm };
